import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import PrivateRoute from "./PrivateRoute";
import Login from "../pages/Login";
import schoolList from "../pages/schoolList";
import AddBoardManager from "../pages/AddBoardManager";
import ForgotPassword from "../pages/ForgotPassword";
import Verification from "../pages/Verification";
import ResetPassword from "../pages/ResetPassword";
import SuccessMessage from "../pages/SuccessMessage";
import SignUp from "../pages/Sign-Up/SignUp";
import VerificationSignUp from "../pages/Sign-Up/VerificationSignUp";
import BoardManagementMain from "../components/common/BoardManagementMain";
import Board_List from "../pages/Board-Management/Board_List";
import Board_List_old from "../pages/Board_List";
import ViewMember from "../pages/Board-Management/View_Member";
import Add_Member from "../pages/Board-Management/Add_Member";
import Add_Note from "../pages/Board-Management/Add_Note";
import School_List from "../pages/School-Management/School_List";
import View_Member from "../pages/School-Management/View_Member";
import Add_School_Member from "../pages/School-Management/Add_Member";
import Add_School_Note from "../pages/School-Management/Add_Note";
import Admissions_main from "../pages/Admission/Admissions_main";
import Faqs_List from "../pages/Admission/Faqs_List";
import Add_faqs from "../pages/Admission/Add_faqs";
import Teacher_List from "../pages/teacher-Management/Teacher_List";
import Teacher_View_Member from "../pages/teacher-Management/Teacher_View_Member";
import Add_teacher_Member from "../pages/teacher-Management/Add_Member";
import Add_teacher_Note from "../pages/teacher-Management/Add_Note";
import EducationMain from "../pages/Education/EducationMain";
import Add_performance from "../pages/Education/Add_performance";
import Add_subject from "../pages/Education/Add_subject";
import Add_stream from "../pages/Education/Add_stream";
import Add_project from "../pages/Education/Add_project";
import Add_facility from "../pages/Education/Add_facility";
import View_facilities from "../pages/Education/View_facilities";
import NewsManagement_main from "../pages/News-Management/NewsManagement_main";
import Add_news from "../pages/News-Management/Add_news";
import View_news from "../pages/News-Management/View_news";
import Department_main from "../pages/Department/Department_main";
import Add_department from "../pages/Department/Add_department";
import View_department from "../pages/Department/View_department";
import Extracurricular_main from "../pages/Extracurricular/Extracurricular_main";
import Add_sports from "../pages/Extracurricular/Add_sports";
import Add_arts from "../pages/Extracurricular/Add_arts";
import Add_clubs from "../pages/Extracurricular/Add_clubs";
import Add_leadership from "../pages/Extracurricular/Add_leadership";
import Add_religious from "../pages/Extracurricular/Add_religious";
import Add_volunteering from "../pages/Extracurricular/Add_volunteering";
import View_sports from "../pages/Extracurricular/View_sports";
import View_arts from "../pages/Extracurricular/View_arts";
import View_club from "../pages/Extracurricular/View_club";
import View_leadership from "../pages/Extracurricular/View_leadership";
import View_religious from "../pages/Extracurricular/View_religious";
import View_volunteering from "../pages/Extracurricular/View_volunteering";
import View_project from "../pages/Education/View_project";
import School_profile from "../pages/School_profile";
import Roles from "../pages/Roles-permission/Roles";
import Add_role from "../pages/Roles-permission/Add_role";
import Admin_main from "../pages/School-Admin-Management/Admin_main";
import Add_admin from "../pages/School-Admin-Management/Add_admin";
import Settings_Main from "../pages/Settings/Settings_Main";
import AdminDashboard from "../pages/AdminDashboard";
import SchoolApprovalList from "../pages/Approval/SchoolApprovalList";
import SchoolReview from "../pages/Approval/SchoolReview";
import SchoolList from "../pages/Super-Admin/SchoolList";
import AddSchool from "../pages/Super-Admin/AddSchool";
import ViewSchool from "../pages/Super-Admin/ViewSchool";
import ContentMain from "../pages/Super-Admin/Cms/ContentMain";
import AddContent from "../pages/Super-Admin/Cms/AddContent";
import { RoliList } from "../pages/Super-Admin/Role and Permission/RoliList";
import AddRole from "../pages/Super-Admin/Role and Permission/AddRole";
import AdminList from "../pages/Super-Admin/Role and Permission/AdminList";
import AddAdmin from "../pages/Super-Admin/Role and Permission/AddAdmin";
import ActivityLogs from "../pages/Super-Admin/ActivityLogs";
import CreditHistory from "../pages/Super-Admin/CreditHistory";
import HorizontalNavigationPage from "../pages/Super-Admin/HorizontalNavigationPage";
import AdminLayout from "../components/include/AdminLayout";
import Country from "../pages/Super-Admin/Country";
import CountryWrapper from "./CountryWrapper";
import SidebarLayout from "../components/common/SidebarLayout";
import { CountryBlocked } from "../components/common/CountryBlocked";
import ParentList from "../pages/Parent-Management/ParentList";
import AddParent from "../pages/Parent-Management/Add";
import ViewParent from "../pages/Parent-Management/ViewParent";
import CommunicationList from "../pages/Communication/CommunicationList";
import AddCommunication from "../pages/Communication/AddCommunication";
import ViewCommunication from "../pages/Communication/ViewCommunication";

const AllRoutes = () => {
  return (
    <Router forceRefresh>
      {/* <CountryWrapper /> */}
      <Routes>
        {/* Country Wrapper */}
        <Route element={<CountryWrapper />}>
          {/* Public */}
          <Route path="/" element={<Login />} />
          <Route path=":country">
            <Route index element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="verify" element={<Verification />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="sussess" element={<SuccessMessage />} />
            <Route path="school-signUp" element={<SignUp />} />
            <Route path="signUp-verify" element={<VerificationSignUp />} />

            <Route element={<SidebarLayout />}>
              <Route element={<PrivateRoute />}>
                <Route path="dashboard" element={<Dashboard />} />

                {/* Profile */}
                <Route path="profile" element={<School_profile />} />

                {/* Board Management */}
                <Route path="board-management" element={<Board_List />} />
                <Route
                  path="board-management/view/:id"
                  element={<ViewMember />}
                />
                <Route
                  path="board-management/add-member"
                  element={<Add_Member />}
                />
                <Route
                  path="board-management/edit-member/:id"
                  element={<Add_Member />}
                />
                <Route
                  path="board-management/add-note"
                  element={<Add_Note />}
                />
                <Route
                  path="board-management/add-file"
                  element={<Add_Note />}
                />
                <Route
                  path="board-management/add-contribution"
                  element={<Add_Note />}
                />
                <Route
                  path="board-management/edit/:id"
                  element={<AddBoardManager />}
                />


            {/* School Management Committee - Same components for Uganda */}
            <Route path="school-management-committee" element={<Board_List />} />
            <Route path="school-management-committee/view/:id" element={<ViewMember />} />
            <Route path="school-management-committee/add-member" element={<Add_Member />} />
            <Route path="school-management-committee/edit-member/:id" element={<Add_Member />} />
            <Route path="school-management-committee/add-note" element={<Add_Note />} />
            <Route path="school-management-committee/add-file" element={<Add_Note />} />
            <Route path="school-management-committee/add-contribution" element={<Add_Note />} />
            <Route path="school-management-committee/edit/:id" element={<AddBoardManager />} />

                {/* School Management */}
                <Route path="school-management" element={<School_List />} />
                <Route
                  path="school-management/view/:id"
                  element={<View_Member />}
                />
                <Route
                  path="school-management/add-member"
                  element={<Add_School_Member />}
                />
                <Route
                  path="school-management/edit-member/:id"
                  element={<Add_School_Member />}
                />
                <Route
                  path="school-management/add-note"
                  element={<Add_School_Note />}
                />
                <Route
                  path="school-management/add-file"
                  element={<Add_School_Note />}
                />
                <Route
                  path="school-management/add-contribution"
                  element={<Add_School_Note />}
                />

                {/* Parent Management */}
                <Route path="parent-management" element={<ParentList />} />
                <Route path="parent-add" element={<AddParent />} />
                <Route path="parent-edit/:id" element={<AddParent />} />
                <Route path="parent-view/:id" element={<ViewParent />} />

                {/* Communication */}
                <Route path="communication" element={<CommunicationList />} />
                <Route path="communication/add" element={<AddCommunication />} />
                <Route path="communication/edit/:id" element={<AddCommunication />} />
                <Route path="communication/view/:id" element={<ViewCommunication />} />

                {/* Teacher Management */}
                <Route path="teacher-management" element={<Teacher_List />} />
                <Route
                  path="teacher-management/view/:id"
                  element={<Teacher_View_Member />}
                />
                <Route
                  path="teacher-management/add-member"
                  element={<Add_teacher_Member />}
                />
                <Route
                  path="teacher-management/edit-member/:id"
                  element={<Add_teacher_Member />}
                />
                <Route
                  path="teacher-management/add-note"
                  element={<Add_teacher_Note />}
                />
                <Route
                  path="teacher-management/add-file"
                  element={<Add_teacher_Note />}
                />
                <Route
                  path="teacher-management/add-contribution"
                  element={<Add_School_Note />}
                />

                {/* Admissions */}
                <Route path="admissions" element={<Admissions_main />} />
                <Route path="admissions/faqs" element={<Faqs_List />} />
                <Route path="admissions/faqs/add" element={<Add_faqs />} />
                <Route path="admissions/faqs/edit/:id" element={<Add_faqs />} />

                {/* Education */}
                <Route path="education" element={<EducationMain />} />
                <Route
                  path="education/performance/add"
                  element={<Add_performance />}
                />
                <Route
                  path="education/performance/edit/:id"
                  element={<Add_performance />}
                />
                <Route path="education/subject/add" element={<Add_subject />} />
                <Route
                  path="education/subject/edit/:id"
                  element={<Add_subject />}
                />
                <Route path="education/streams/add" element={<Add_stream />} />
                <Route
                  path="education/streams/edit/:id"
                  element={<Add_stream />}
                />
                <Route
                  path="education/projects/add"
                  element={<Add_project />}
                />
                <Route
                  path="education/projects/edit/:id"
                  element={<Add_project />}
                />
                <Route
                  path="education/projects/view/:id"
                  element={<View_project />}
                />
                <Route
                  path="education/facilities/add"
                  element={<Add_facility />}
                />
                <Route
                  path="education/facilities/edit/:id"
                  element={<Add_facility />}
                />
                <Route
                  path="education/facilities/view/:id"
                  element={<View_facilities />}
                />

                {/* News Management */}
                <Route
                  path="news-management"
                  element={<NewsManagement_main />}
                />
                <Route path="news-management/add" element={<Add_news />} />
                <Route path="news-management/edit/:id" element={<Add_news />} />
                <Route
                  path="news-management/view/:id"
                  element={<View_news />}
                />

                {/* Department */}
                <Route path="department" element={<Department_main />} />
                <Route path="department/add" element={<Add_department />} />
                <Route
                  path="department/edit/:id"
                  element={<Add_department />}
                />
                <Route
                  path="department/view/:id"
                  element={<View_department />}
                />

                {/* Extracurricular */}
                <Route
                  path="extracurricular"
                  element={<Extracurricular_main />}
                />
                <Route
                  path="extracurricular/sports/add"
                  element={<Add_sports />}
                />
                <Route
                  path="extracurricular/sports/edit/:id"
                  element={<Add_sports />}
                />
                <Route
                  path="extracurricular/sports/view/:id"
                  element={<View_sports />}
                />
                <Route path="extracurricular/arts/add" element={<Add_arts />} />
                <Route
                  path="extracurricular/arts/edit/:id"
                  element={<Add_arts />}
                />
                <Route
                  path="extracurricular/arts/view/:id"
                  element={<View_arts />}
                />
                <Route
                  path="extracurricular/clubs/add"
                  element={<Add_clubs />}
                />
                <Route
                  path="extracurricular/clubs/edit/:id"
                  element={<Add_clubs />}
                />
                <Route
                  path="extracurricular/clubs/view/:id"
                  element={<View_club />}
                />
                <Route
                  path="extracurricular/leadership/add"
                  element={<Add_leadership />}
                />
                <Route
                  path="extracurricular/leadership/edit/:id"
                  element={<Add_leadership />}
                />
                <Route
                  path="extracurricular/leadership/view/:id"
                  element={<View_leadership />}
                />
                <Route
                  path="extracurricular/religious/add"
                  element={<Add_religious />}
                />
                <Route
                  path="extracurricular/religious/edit/:id"
                  element={<Add_religious />}
                />
                <Route
                  path="extracurricular/religious/view/:id"
                  element={<View_religious />}
                />
                <Route
                  path="extracurricular/volunteering/add"
                  element={<Add_volunteering />}
                />
                <Route
                  path="extracurricular/volunteering/edit/:id"
                  element={<Add_volunteering />}
                />
                <Route
                  path="extracurricular/volunteering/view/:id"
                  element={<View_volunteering />}
                />

                {/* Role & Permissions */}
                <Route path="role" element={<Roles />} />
                <Route path="role/add" element={<Add_role />} />
                <Route path="role/edit/:id" element={<Add_role />} />

                {/* Admin Management */}
                <Route path="subadmin" element={<Admin_main />} />
                <Route path="subadmin/add" element={<Add_admin />} />
                <Route path="subadmin/edit/:id" element={<Add_admin />} />

                {/* Settings */}
                <Route path="settings" element={<Settings_Main />} />

                {/* Super Admin */}
                <Route path="admin-dashboard" element={<AdminDashboard />} />
                <Route
                  path="admin-approvals"
                  element={<SchoolApprovalList />}
                />
                <Route path="school-approval/:id" element={<SchoolReview />} />
                <Route path="admin-school" element={<SchoolList />} />
                <Route path="admin-school/add" element={<AddSchool />} />
                <Route
                  path="navigation-dashboard"
                  element={<HorizontalNavigationPage />}
                />
                <Route path="admin-school/edit/:id" element={<AddSchool />} />
                <Route path="admin-school/view/:id" element={<ViewSchool />} />
                <Route path="admin-content" element={<ContentMain />} />
                <Route path="admin-content/add" element={<AddContent />} />
                <Route path="admin-content/edit/:id" element={<AddContent />} />
                <Route path="admin-role" element={<RoliList />} />
                <Route path="admin-role/add" element={<AddRole />} />
                <Route path="admin-role/edit/:id" element={<AddRole />} />
                <Route path="admin-subadmin" element={<AdminList />} />
                <Route path="admin-subadmin/add" element={<AddAdmin />} />
                <Route path="admin-subadmin/edit/:id" element={<AddAdmin />} />
                <Route path="admin-activity" element={<ActivityLogs />} />
                <Route path="admin-credit-history" element={<CreditHistory />} />
                <Route path="admin-settings" element={<Country />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="/country-blocked" element={<CountryBlocked />} />
      </Routes>
    </Router>
  );
};

export default AllRoutes;
